export default __webpack_public_path__ + "static/media/logo.7bd82377.svg";